import styled from 'styled-components'

export const ContainerAnima = styled.div`
    background-color: var(--background-one);
    color: var(--text-body);
    display: flex;
    flex-flow: column;
    flex-wrap: wrap;
    align-content: center;
    text-align: center;
    width: 100%;
    
    h2 {
        font-size: 34px;
        margin-top: 8rem;
        margin-bottom: 2rem;

    }
    .subtitle {
        color: var(--background-season-2);
        font-weight: 600;
        font-size: 18px;
    }
    div p {
        margin-bottom: 2rem;
    }
    .text-anima {
        /* max-height: 47px; */
        max-width: 570px;
        margin: 0 auto;
        line-height: 2rem;
        min-width: 300px;
    }

    @media(max-width: 768px) {
        h2 {
            font-size: 30px;
        }
        .subtitle {
            font-size: 18px;
        }
        .text-anima {
            font-size: 16px;
        }
    }

`